import { WeaverQuery } from 'Services/WeaverUtils'
import defaultConfig from './default'
import getCreateEntityActionPages from './create-entities'

Q = ->
  query = new Weaver.Query()
  query.str = -> JSON.stringify(query)
  query

createEntityActionPages = getCreateEntityActionPages(Q)
defaultConfig.actionsPages = [defaultConfig.actionsPages..., createEntityActionPages...]

export default {
  defaultConfig...

  booleanLabels: {
    status: { false: 'Declined', true: 'Approved' }
  }

  queries: []
  permissions: [
    {
      rel_key: 'test'
      function_access: ["may_approve"]
      write: true
      permitted_targets: ["aggregation-operator", "map-operator"]
      delete: false
      change_rel_key: false
    }, {
      rel_key: 'hasFriend'
      function_access: ["acl-administration"]
      write: true
      delete: false
      change_rel_key: false
    }, {
      rel_key: 'hasStatus'
      function_access: ["user-administration"]
      write: true
      permitted_targets: ["declined"]
      delete: false
      change_rel_key: false
    }
  ]
}
